import { render, staticRenderFns } from "./pin-dialog.vue?vue&type=template&id=b11c6668&"
import script from "./pin-dialog.vue?vue&type=script&lang=js&"
export * from "./pin-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports